<template>
  <div class="Setting">
    <el-tabs v-model="active_tab" type="card" @tab-click="handleClick">
      <el-tab-pane label="Banners" name="1">
        <Banner v-if="active_tab==='1'"></Banner>
      </el-tab-pane>
      <el-tab-pane label="Convert" name="2">
        <Convert v-if="active_tab==='2'"></Convert>
      </el-tab-pane>
<!--      <el-tab-pane label="Distance" name="3">-->

<!--      </el-tab-pane>-->
      <el-tab-pane label="Clockin/Login/Mindfulness" name="4">
        <Reward v-if="active_tab==='4'"></Reward>
      </el-tab-pane>
      <el-tab-pane label="Invite Reward" name="5">
        <InviteReward v-if="active_tab==='5'"></InviteReward>
      </el-tab-pane>
     <el-tab-pane label="Door Control" name="6">
        <DoorControl v-if="active_tab==='6'"></DoorControl>
     </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import Banner from "@/components/Setting/Banner/Banner";
  import Convert from "@/components/Setting/Convert/Convert";
  import Reward from "@/components/Setting/Reward/Reward";
  import InviteReward from "@/components/Setting/Reward/Invite";
  import DoorControl from "@/components/Setting/DoorControl/DoorControl";

  export default {
    components:{
      Banner,
      Convert,
      Reward,
      InviteReward,
      DoorControl
    },
    data() {
      return {
        active_tab: '1'
      };
    },
    methods: {
      handleClick() {}
    }
  };
</script>

<style lang="scss">
  @import "_Setting.scss";
</style>